export default __webpack_public_path__ + "SAt_history.html";